export const AbstractModelSchema = {
    fields: {
        _id: {
            type: 'mongoId',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
        createdAt: {
            type: 'timestamp',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
        updatedAt: {
            type: 'timestamp',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
    },
};
//# sourceMappingURL=abstract_model_schema.js.map